/* eslint-disable global-require */
export default {
  googlefit: {
    img: require('../img/apps/google-fit-app.png'),
    name: 'Google Fit',
  },
  strava: {
    img: require('../img/apps/strava-app.png'),
    name: 'Strava',
  },
  polar: {
    img: require('../img/apps/polar-app.png'),
    name: 'Polar',
  },
  garmin: {
    img: require('../img/apps/garmin-app.png'),
    name: 'Garmin',
  },
  fitbit: {
    img: require('../img/apps/fitbit-app.png'),
    name: 'Fitbit',
  },
  nike: {
    img: require('../img/apps/nike-plus-app.png'),
    name: 'Nike+',
  },
  runkeeper: {
    img: require('../img/apps/runkeeper-app.png'),
    name: 'Runkeeper',
  },
  runtastik: {
    img: require('../img/apps/runtastic-app.png'),
    name: 'Runtastic',
  },
  suunto: {
    img: require('../img/apps/suunto-app.png'),
    name: 'Suunto',
  },
  simplerun: {
    img: require('../img/apps/simple-run-app.png'),
    name: 'Simple Run',
  },
  scounttracker: {
    img: require('../img/apps/scount-app.png'),
    name: 'СКАУНТ',
  },
  scounthealth: {
    img: require('../img/apps/scount-health-app.png'),
    name: 'Другой трекер',
  },
};
